import { createFileRoute } from "@tanstack/react-router";
import { SettingsLayout } from "../../components/Settings/SettingsLayout";

export const Route = createFileRoute("/settings")({
	component: SettingsLayout,
});
